import React, {useEffect, useState} from 'react';
import {Dispatch, bindActionCreators} from 'redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {RootState} from '../../reducers';
import * as actions from '../../actions/generalActions';
import * as offerActions from '../../actions/offers';
import * as clientActions from '../../actions/client';
import * as measuresActions from '../../actions/measures'
import * as agreementsActions from '../../actions/agreements'
import {withRouter} from 'react-router';
import PICFile from "../../assets/icons/pic.svg";
import './DataTransferComponent.scss'
import moment from "moment";
import {LatLngExpression} from "leaflet";
import {isMobile} from "../../constants/constants";

interface Props {
    intl: any;
    actions: any;
    client: any;
    clientActions: any;
    measures: any,
    measuresActions: any;
    offers: any;
    offerActions: any;
    measureNeeded?: boolean,
    offerNeeded?: boolean;
    agreementNeeded?: boolean,
    agreements: any
    agreementsActions: any;
    clientId?: number,
    projectDetails: any
    noProjectDetails?: boolean
    noContactDetails?: boolean
}

const DataTransferComponent = (props: Props) => {

    const [measureAssets, setMeasureAssets] = useState([])
    const [offerAssets, setOfferAssets] = useState([])
    const [agreementAssets, setAgreementAssets] = useState([])
    const [projectDetails, setProjectDetails] = useState<any>([])
    const [measure, setMeasure] = useState<any>({})
    const [offer, setOffer] = useState<any>({})
    const [agreement, setAgreement] = useState<any>({})
    const [position, setPosition] = useState<LatLngExpression>()

    useEffect(()=>{
        getCurrentPosition()
    },[])

    function getCurrentPosition() {
        navigator.geolocation.getCurrentPosition(function (geoLocationPosition) {
            if (geoLocationPosition?.coords?.latitude && geoLocationPosition?.coords?.longitude) {
                console.log(geoLocationPosition?.coords)
                setPosition([geoLocationPosition.coords.latitude, geoLocationPosition.coords.longitude])
            }
        },(err)=> {
            console.warn(`ERROR(${err.code}): ${err.message}`)
        }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 60000,
        });
    }

    useEffect(() => {
        setMeasure(props?.projectDetails?.measure ? props?.projectDetails?.measure : {})
        setOffer(props?.projectDetails?.offer ? props?.projectDetails?.offer : {})
        setAgreement(props?.projectDetails?.agreement ? props?.projectDetails?.agreement : {})
        setProjectDetails(props?.projectDetails ? props?.projectDetails : {})
    }, [props.projectDetails])

    useEffect(() => {
        let tempArray = []
        measure?.measureFiles?.forEach((file) => {
            if (file?.measureWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.measureWithUrl, name: file?.measureName})
            } else if (file?.pictureWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.pictureWithUrl, name: file?.pictureName})
            } else if (file?.sketchWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.sketchWithUrl, name: file?.sketchName})
            }
        })
        setMeasureAssets(tempArray)
    }, [measure])

    useEffect(() => {
        let tempArray = []
        offer?.offerFiles?.forEach((file) => {
            if (file?.finalOfferWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.finalOfferWithUrl, name: file?.finalOfferName})
            } else if (file?.pdfOfferWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.pdfOfferWithUrl, name: file?.pdfOfferName})
            } else if (file?.requirementWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.requirementWithUrl, name: file?.requirementName})
            }
        })
        setOfferAssets(tempArray)
    }, [offer])

    useEffect(() => {
        let tempArray = []
        agreement?.agreementFiles?.forEach((file) => {
            if (file?.signatureWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.signatureWithUrl, name: file?.signature})
            } else if (file?.finalAgreementWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.finalAgreementWithUrl, name: file?.finalAgreementName})
            } else if (file?.annexesWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.annexesWithUrl, name: file?.annexes})
            } else if (file?.cancelationWithUrl) {
                tempArray.push({id: file.id, fileUrl: file?.cancelationWithUrl, name: file?.cancelation})
            }
        })
        setAgreementAssets(tempArray)
    }, [agreement])

    return <div className="gatheredInfoWrapper">
        <div className={'gatheredInfoContainer'}>
            {(!props?.noProjectDetails) && <div className="projectDetails">
                <div className="data-section">
                    <div className="data">
                        <p className="labelData"><FormattedMessage id="dataTransfer.projectName" defaultMessage="Project name:" /></p>
                        <p>{projectDetails?.projectName}</p>
                    </div>
                    <div className="data">
                        <p className="labelData"><FormattedMessage id="dataTransfer.projectLocation" defaultMessage="Project location:" /></p>
                        {projectDetails?.projectLocation ? (
                            <a href={`https://www.google.com/maps/?q=${projectDetails?.projectLocation}`}
                               target='_blank' className="location-value-link">
                                {projectDetails?.projectLocation}
                            </a>
                        ) : <p></p>}
                    </div>
                </div>
            </div>}
            <div className={`d-flex ${isMobile ? "flex-wrap": ""}`}>
                {props.client?.client && (!props?.noContactDetails) && <div className="col-flex">
                    <div className={'data'}>
                        <p className={'labelData'}><FormattedMessage id="dataTransfer.contact" defaultMessage="Contact" /></p>
                    </div>
                    {projectDetails?.projectFiles?.length !== 0 &&
                    <>
                        <p className="small-text product-measure-photos">
                            <FormattedMessage id="dataTransfer.contactAssets" defaultMessage="Contact assets" />
                        </p>
                        {projectDetails?.projectFiles?.map((item, id) => {
                            return (
                                <div className="d-flex align-items-center mb-2 cursor-pointer" key={id}>
                                    <img className="product-pic m-1" src={PICFile} alt="pic"/>
                                    <a target={'_blank'} href={item?.fileUrl} className="link-pics">{item?.fileName}</a>
                                </div>
                            )
                        })}
                    </>
                    }
                    <div className="data-section">
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.phone" defaultMessage="Phone:" /></p>
                            <p>{props.client?.client?.phoneNumber}</p>
                        </div>
                        <div className="data">
                            <div>
                                <p className="labelData"><FormattedMessage id="dataTransfer.address" defaultMessage="Address:" /></p>
                                <p>{props.client?.client?.address}</p>
                            </div>
                        </div>
                        <div className="data">
                            <div>
                                <p className="labelData"><FormattedMessage id="dataTransfer.city" defaultMessage="City:" /></p>
                                <p className="city">{props.client?.client?.city}</p>
                            </div>
                        </div>
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.country" defaultMessage="Country:" /></p>
                            <p>{props.client?.client?.country}</p>
                        </div>
                    </div>
                </div>}
                {props.measureNeeded && <div className="col-flex">
                    <div className={'data'}>
                        <p className={'labelData'}><FormattedMessage id="dataTransfer.measure" defaultMessage="Measurement" /></p>
                    </div>
                    {measureAssets?.length !== 0 &&
                    <>
                        <p className="small-text product-measure-photos">
                            <FormattedMessage id="dataTransfer.measureAssets" defaultMessage="Measurement assets" />
                        </p>
                        {measureAssets?.map((item, id) => {
                            return (
                                <div className="d-flex align-items-center mb-2 cursor-pointer" key={id}>
                                    <img className="product-pic m-1" src={PICFile} alt="pic"/>
                                    <a target={'_blank'} href={item?.fileUrl} className="link-pics">{item?.name}</a>
                                </div>
                            )
                        })}
                    </>
                    }
                    <div className="data-section">
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.measureStatus" defaultMessage="Measurement status:" /></p>
                            <p>{measure?.status?.label}</p>
                        </div>
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.measureDate" defaultMessage="Measurement date:" /></p>
                            <p>{measure?.startDate}</p>
                        </div>
                        <div className="data">
                            <div>
                                <p className="labelData"><FormattedMessage id="dataTransfer.clientLocation" defaultMessage="Client location:" /></p>
                                {measure?.productLocation && position ? (
                                    <a target='_blank'
                                       href={`https://www.google.com/maps/dir/${position[0]},${position[1]}/${measure?.productLocation}/@${position[0]},${position[1]},15z?entry=ttu`}
                                       className="location-value-link city">
                                        {measure?.productLocation}
                                    </a>
                                ) : (
                                    <p className="city">{measure?.productLocation}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>}
                {props?.offerNeeded && <div className="col-flex">
                    <div className={'data'}>
                        <p className={'labelData'}><FormattedMessage id="dataTransfer.offer" defaultMessage="Offer" /></p>
                    </div>
                    {offerAssets?.length !== 0 &&
                    <>
                        <p className="small-text product-measure-photos">
                            <FormattedMessage id="dataTransfer.offerAssets" defaultMessage="Offer assets" />
                        </p>
                        {offerAssets?.map((item, id) => {
                            return (
                                <div className="d-flex align-items-center mb-2 cursor-pointer" key={id}>
                                    <img className="product-pic m-1" src={PICFile} alt="pic"/>
                                    <a target={'_blank'} href={item?.fileUrl} className="link-pics">{item?.name}</a>
                                </div>
                            )
                        })}
                    </>
                    }
                    <div className="data-section">
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.offerDate" defaultMessage="Offer date:" /></p>
                            <p>{moment(offer?.offerDate).format('DD.MM.YYYY')}</p>
                        </div>

                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.offerStatus" defaultMessage="Offer status:" /></p>
                            <p className="city">{offer?.offerStatus?.label}</p>
                        </div>
                    </div>
                </div>}
                {props?.agreementNeeded && <div className="col-flex">
                    <div className="data-section">
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.prepaid" defaultMessage="Down payment:" /></p>
                            <p>{agreement?.prepaid}</p>
                        </div>

                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.remainingDebt" defaultMessage="Remaining debt:" /></p>
                            <p className="city">{agreement?.totalDebtLeft}</p>
                        </div>
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.total" defaultMessage="Total:" /></p>
                            <p>{agreement?.total}</p>
                        </div>
                        <div className="data">
                            <p className="labelData"><FormattedMessage id="dataTransfer.agreementStatus" defaultMessage="Agreement status:" /></p>
                            <p>{agreement?.agreementStatus?.label}</p>
                        </div>
                    </div>
                    {agreementAssets?.length !== 0 &&
                    <>
                        <p className="small-text product-measure-photos">
                            <FormattedMessage id="dataTransfer.agreementAssets" defaultMessage="Agreement assets" />
                        </p>
                        {agreementAssets?.map((item, id) => {
                            return (
                                <div className="d-flex align-items-center mb-2 cursor-pointer" key={id}>
                                    <img className="product-pic m-1" src={PICFile} alt="pic"/>
                                    <a target={'_blank'} href={item?.fileUrl} className="link-pics">{item?.name}</a>
                                </div>
                            )
                        })}
                    </>
                    }
                </div>}
            </div>

            <div className={`d-flex ${isMobile ? "flex-wrap" : ""}`}>
                {(!props?.noProjectDetails) && <div className="col-flex comment">
                    <p><FormattedMessage id="dataTransfer.projectComments" defaultMessage="Project comments" /></p>
                    <p>{projectDetails?.projectComment}</p>
                </div>}

                {props.measureNeeded && <div className="col-flex comment">
                    <p><FormattedMessage id="dataTransfer.measureComments" defaultMessage="Measurement comments" /></p>
                    <p>{measure?.details}</p>
                </div>}

                {props.offerNeeded && <div className="col-flex comment">
                    <p><FormattedMessage id="dataTransfer.offerComments" defaultMessage="Offer comments" /></p>
                    <p>{offer?.addition}</p>
                </div>}

                {props.agreementNeeded && <div className="col-flex comment">
                    <p><FormattedMessage id="dataTransfer.agreementComments" defaultMessage="Agreement comments" /></p>
                    <p>{agreement?.comment}</p>
                </div>}
            </div>
        </div>
    </div>
}

function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        measures: state.measures,
        offers: state.offers,
        agreements: state.agreements
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        measuresActions: bindActionCreators(measuresActions as any, dispatch),
        offerActions: bindActionCreators(offerActions as any, dispatch),
        clientActions: bindActionCreators(clientActions as any, dispatch),
        actions: bindActionCreators(actions as any, dispatch),
        agreementsActions: bindActionCreators(agreementsActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(DataTransferComponent as any)));